import gql from 'graphql-tag';

export const MONTHLY_DISTRIBUTION = gql`
    query MonthlyDistribution($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            averageAnnualTotalReturns {
                quarterly {
                    asOfDate
                }
            }
            thirtyDaySECDividend
            thirtyDaySECDividendAsOfDate
            unsubsidizedThirtyDaySECYield
            unsubsidizedThirtyDaySECYieldAsOfDate
            distribution {
                distributionFrequency
                distributions {
                    exDate
                    totalDistribution
                }
            }
            distributionMetrics {
                asOfDate
                distMetricsData {
                    distributionRate
                    distributionAmount
                    twelveMonthTrailingDistributionRate
                    rateDate
                }
            }
        }
    }
`;
